import React from "react";
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import aboutimg from "../asset/4.jpg";
import engineeringImg from "../asset/image1.jpeg";

const Home = () => {
  return (
    <div>
      <section className="hero" id="hero">
        <Container>
          <Row>
            <Col lg={12} md={12} sm={12} className="text-center">
              <h1>Innovative Engineering. Reliable Execution.</h1>
              <p>
                From cable assemblies to complete engineering and contracting
                solutions.
              </p>
              <Button href="#about" variant="primary" className="btn-primary">
                Explore Pramodaya
              </Button>
            </Col>
          </Row>
        </Container>
      </section>

      {/* about */}
      <section className="about" id="about">
        <Container>
          <Row>
            <Col lg={12} md={12} sm={12}>
              <h2 className="title text-center">
                Empowering Innovation Through Precision Engineering.
              </h2>
              <p className="text-center">
                At Pramodaya, we are a technology-driven company dedicated to
                delivering precision-engineered solutions in cable assembly,
                electronics integration, and end-to-end engineering support. Our
                mission is to empower businesses with innovative, dependable,
                and performance-focused services that address complex challenges
                with clarity and care. Backed by a skilled team and cutting-edge
                technology, we ensure every project reflects our commitment to
                quality, efficiency, and long-term value. More than a service
                provider, Pramodaya is your trusted partner in driving progress
                through engineering excellence.
              </p>
            </Col>
          </Row>

          <Row>
            <Col lg={6} md={6} sm={12}>
              <h4 className="title">Vision</h4>
              <p>
                Our vision is to be a global leader in engineering excellence
                and technological innovation. We aim to transform cable assembly
                and integration with future-ready, high-performance solutions.
                Through integrity, innovation, and collaborative partnerships,
                we strive to be the most trusted, forward-thinking ally in an
                ever-evolving technological landscape.
              </p>
              <h4 className="title">Mission</h4>
              <p>
                Pramodaya delivers expert solutions in cable assembly,
                electronics integration, and engineering support. We focus on
                precision, quality, and innovation to solve complex challenges.
                Through advanced technology, skilled talent, and customer
                commitment, we aim to create long-term value and empower our
                clients with dependable, high-performance engineering services.
              </p>
            </Col>
            <Col lg={6} md={6} sm={12}>
              <img className="img-fluid" src={aboutimg} alt="about-image" />
            </Col>
          </Row>
        </Container>
      </section>

      {/* Engineering Solutions */}
      <section className="engineering-solutions" id="engineering">
        <Container>
          <Row className="align-items-center gy-5">
            <Col lg={6}>
              <div className="engineering-image">
                <img
                  src={engineeringImg}
                  alt="Engineering Solutions"
                  className="img-fluid"
                />
              </div>
            </Col>

            <Col lg={6}>
              <span className="section-tag">ENGINEERING SOLUTIONS</span>

              <h2 className="engineering-title">
                Comprehensive Building Engineering & Smart Infrastructure
                Solutions
              </h2>

              <p className="engineering-text">
                Pramodaya delivers complete engineering solutions for
                commercial, industrial and infrastructure projects. We provide
                HVAC instrumentation, building automation, energy management,
                electrical systems, air quality monitoring and industrial
                engineering products through globally trusted technology
                partners.
              </p>

              <Row className="g-3 mt-2">
                <Col sm={6}>
                  <div className="solution-card">
                    <h6>HVAC & Building Automation</h6>
                    <ul>
                      <li>BTU & Flow Meters</li>
                      <li>Motorized Valves</li>
                      <li>VAV Boxes</li>
                      <li>IBMS Solutions</li>
                    </ul>
                  </div>
                </Col>

                <Col sm={6}>
                  <div className="solution-card">
                    <h6>Indoor Air Quality</h6>
                    <ul>
                      <li>ESP Air Cleaners</li>
                      <li>UV Systems</li>
                      <li>OH Radical Systems</li>
                      <li>Air Quality Sensors</li>
                    </ul>
                  </div>
                </Col>

                <Col sm={6}>
                  <div className="solution-card">
                    <h6>Electrical & ELV</h6>
                    <ul>
                      <li>Lighting Control</li>
                      <li>Fire Alarm</li>
                      <li>CCTV</li>
                      <li>Access Control</li>
                    </ul>
                  </div>
                </Col>

                <Col sm={6}>
                  <div className="solution-card">
                    <h6>Energy Solutions</h6>
                    <ul>
                      <li>EV Chargers</li>
                      <li>UPS Systems</li>
                      <li>Power Management</li>
                      <li>Vacuum Degasser</li>
                    </ul>
                  </div>
                </Col>
              </Row>

              <div className="partner-strip mt-4">
                <strong>Technology Partners</strong>

                <div className="partner-list">
                  <span>Honeywell</span>
                  <span>Eaton</span>
                  <span>Panasonic</span>
                  <span>Reflex</span>
                  <span>Omicron</span>
                  <span>Elixir</span>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* services */}
      <section className="services" id="services">
        <Container>
          <Row className="mb-4">
            <Col>
              <h2 className="servicetitle">Our Services</h2>
              <p>End-to-End Engineering & Assembly Solutions</p>
              <p>
                At Pramodaya, we deliver precision-engineered cable assembly
                solutions including power, RF, data, earthing, and RJ-45
                cables—built for performance and durability.
              </p>
            </Col>
          </Row>

          <Row>
            <Col lg={4} md={4} sm={12} className="mb-4">
              <Card className="card">
                <Card.Body>
                  <Card.Title className="card-title">
                    High-Reliability Cable Assemblies
                  </Card.Title>
                  <Card.Text className="card-text">
                    We engineer precision-built interconnect solutions designed
                    to perform in extreme environments and mission-critical
                    applications where reliability, durability, and signal
                    integrity are non-negotiable.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={4} md={4} sm={12} className="mb-4">
              <Card className="card">
                <Card.Body>
                  <Card.Title className="card-title">
                    RF & Microwave Assemblies
                  </Card.Title>
                  <Card.Text className="card-text">
                    Low-loss coaxial cable assemblies engineered for
                    high-frequency performance, stable signal transmission, and
                    minimal attenuation across demanding RF and microwave
                    applications.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={4} md={4} sm={12} className="mb-4">
              <Card className="card">
                <Card.Body>
                  <Card.Title className="card-title">
                    High-Speed Data Interconnects
                  </Card.Title>
                  <Card.Text className="card-text">
                    Advanced data cable assemblies supporting high-speed
                    transmission through Aviation, DVI, and HDMI connectors for
                    dependable connectivity.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={4} md={4} sm={12} className="mb-4">
              <Card className="card">
                <Card.Body>
                  <Card.Title className="card-title">
                    Military-Grade Power & Control Systems
                  </Card.Title>
                  <Card.Text className="card-text">
                    Ruggedized power and control assemblies utilizing Circular
                    Connectors and Euro Connectors built for tactical,
                    industrial, and heavy-duty operational environments.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={4} md={4} sm={12} className="mb-4">
              <Card className="card">
                <Card.Body>
                  <Card.Title className="card-title">
                    Mission-Critical System Integration
                  </Card.Title>
                  <Card.Text className="card-text">
                    Beyond cable manufacturing, we deliver complete system
                    integration solutions optimized for performance, protection,
                    and serviceability in compact and high-density electronic
                    systems.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={4} md={4} sm={12} className="mb-4">
              <Card className="card">
                <Card.Body>
                  <Card.Title className="card-title">
                    Advanced Cable Routing & Ducting
                  </Card.Title>
                  <Card.Text className="card-text">
                    Precision-engineered cable routing and ducting solutions
                    designed for organized integration within sensitive and
                    space-constrained electronic equipment.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={4} md={4} sm={12} className="mb-4">
              <Card className="card">
                <Card.Body>
                  <Card.Title className="card-title">
                    Strategic Housing & Layout Design
                  </Card.Title>
                  <Card.Text className="card-text">
                    Custom internal layout and housing configurations developed
                    to maximize airflow efficiency, thermal management,
                    accessibility, and long-term maintenance reliability.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={4} md={4} sm={12} className="mb-4">
              <Card className="card">
                <Card.Body>
                  <Card.Title className="card-title">
                    Engineering Services
                  </Card.Title>
                  <Card.Text className="card-text">
                    Our expert engineers provide end-to-end support in design,
                    integration, and optimization. We help streamline operations
                    and enhance technical performance with customized solutions.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={4} md={4} sm={12} className="mb-4">
              <Card className="card">
                <Card.Body>
                  <Card.Title className="card-title">
                    Material Supply & Manpower
                  </Card.Title>
                  <Card.Text className="card-text">
                    We supply top-quality materials and skilled or unskilled
                    manpower as per project requirements. Our efficient team
                    ensures timely project delivery and optimal execution.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={4} md={4} sm={12} className="mb-4">
              <Card className="card">
                <Card.Body>
                  <Card.Title className="card-title">
                    Operations & Maintenance
                  </Card.Title>
                  <Card.Text className="card-text">
                    We offer comprehensive operations and maintenance services
                    to minimize downtime. Our solutions ensure long-term
                    equipment reliability and smooth operational performance.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={4} md={4} sm={12} className="mb-4">
              <Card className="card">
                <Card.Body>
                  <Card.Title className="card-title">
                    Civil & Interior Contracting Services
                  </Card.Title>
                  <Card.Text className="card-text">
                    We provide complete civil and interior contracting services
                    including masonry, plastering, PCC work, tiling, and turnkey
                    interior execution. Our experience ensures reliable
                    workmanship and consistent project delivery.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* contact */}
      <section className="contact" id="contact">
        <Container>
          <Row>
            <Col>
              <h2 className="contact-title">
                Ready to power your projects with precision and expertise?
              </h2>
              <p className="contact-para">
                Get in touch with Pramodaya today for reliable cable assembly,
                engineering support, and skilled manpower solutions.
              </p>
            </Col>
          </Row>

          <Row>
            <Col lg={6} md={6} sm={12} className="left">
              <iframe
                title="Pramodaya Office Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3857.9895709784246!2d74.16580987487619!3d14.769617585736993!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bbe61778114ca93%3A0x9f91625c679364f!2sIce%20Factory%20Chendia!5e0!3m2!1sen!2sin!4v1780236190833!5m2!1sen!2sin"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </Col>

            <Col lg={6} md={6} sm={12} className="right">
              {/* Address */}
              <h5>Address:</h5>
              <p>
                Mahalsa Sadan, Near Maruti Temple, <br /> Ice Factory, Chendiye,
                Karwar, Karnataka - 581324.
              </p>
              <h5>Phone:</h5>
              <p>Dayanand Naik: +91 7738935653 | Pramod Naik: +91 9821587337</p>

              <h5>Email:</h5>
              <p>team@pramodaya.in</p>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default Home;
